import { useTranslation } from "react-i18next";
import { toPeriodMessageLines } from "../../../../Utils";

/**
 * PeriodRowNote — the amber line under a date in an import table, saying why
 * that row cannot be saved.
 *
 * Amber, never red: the row parsed correctly, the books are simply closed.
 *
 * The backend's message is two sentences and the date cell is nowrap, so
 * printed as-is it became one long line that dragged the column past the
 * viewport. Each sentence gets its own line here, and `whitespace-normal`
 * overrides the cell so a long one wraps inside the column instead of widening
 * it. The wording itself is untouched — it already names the boundary date and
 * the recovery step.
 *
 * `message` is null for a row the server listed without a reason of its own
 * (and for the draft screen, which derives its rows from the boundary rather
 * than from a response), so the generic wording stands in.
 */
const PeriodRowNote = ({ message, className = "" }) => {
  const { t } = useTranslation();

  const lines = toPeriodMessageLines(
    message || t("accounting.period.lockedRow"),
  );

  return (
    <span
      className={`mt-0.5 block max-w-xs whitespace-normal text-xs text-amber-700 ${className}`}
    >
      {lines.map((line) => (
        <span key={line} className="block">
          {line}
        </span>
      ))}
    </span>
  );
};

export default PeriodRowNote;
